module.exports = __webpack_public_path__ + "first-50-paper.jpg?5e69099cf264791d4e225a86ec09324b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-50-paper.jpg
// module id = 530
// module chunks = 0